module.exports = __webpack_public_path__ + "static/media/04510007-EJf1wSgs.5147b76b.JPG";